import React from 'react';
import { Badge } from '@amzn/awsui-components-react';

export function CloudQuestBadge({ isBoltOnClass }: { isBoltOnClass: boolean }) {
    if (!isBoltOnClass) return null;
    return <Badge color='green'>AWS Cloud Quest</Badge>;
}
